import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';

const ListFilter = (props: any) => {
  return <Filter {...(props || {})}></Filter>;
};

const ChainsManagement = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  return (
    <DashboardContent>
      <PermissionGuard resource="swap-chains" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.swapChainsManagement')}
          links={[
            { name: translate('resource.swapChainToken'), href: '#' },
            {
              name: translate('resource.swapChainsManagement'),
              href: `/${Resources.swapChainsManagement}`,
            },
            { name: translate('resource.list') },
          ]}
          // action={
          //   <PermissionGuard resource="swap-chains" action="create" fallback={<></>}>
          //     <CreateButton variant="contained" size='medium' onClick={(e)=> {
          //       e.preventDefault()
          //       setPopup(<CreateMetadata onClose={() => setPopup(undefined)} />)
          //     }} />
          //   </PermissionGuard>
          // }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            perPage={10}
            exporter={false}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="swap-chains" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                {/* <TextField source="id" label="module.swapChainsManagement.id" sortable={false} /> */}
                <TextField
                  source="name"
                  label="module.swapChainsManagement.name"
                  sortable={false}
                />
                <FunctionField
                  label="module.swapChainsManagement.isActive"
                  render={(record) => (
                    <Chip
                      label={record.isActive ? 'True' : 'False'}
                      color={record.isActive ? 'success' : 'error'}
                      size="small"
                    />
                  )}
                  sortable={false}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default ChainsManagement;
